module.exports = __webpack_public_path__ + "static/media/amazing_restaurant_steak.10f06dff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/amazing_restaurant_steak.jpg
// module id = 300
// module chunks = 0